<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('CompanyManagement.companyNum')">
                    <el-input
                      size="mini"
                      v-model="formInline.companyNum"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('CompanyManagement.name')">
                    <el-input
                      size="mini"
                      v-model="formInline.name"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{ $t("common.btn.search") }}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del">{{
                      $t("common.btn.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                  type="text"
                  :disabled="selected.length != 1"
                  @click="transferCar"
                  >{{ $t("CompanyManagement.bindOrg") }}</el-button
                >
                <el-button
                  type="text"
                  :disabled="selected.length != 1"
                  @click="editCompany"
                  >{{ $t("common.btn.edit") }}</el-button
                >
                <el-button
                  type="text"
                  :disabled="selected.length != 1"
                  @click="deleteCompany"
                  >{{ $t("common.btn.delete") }}</el-button
                >
                <el-button type="text" @click="addCompany">{{
                  $t("common.btn.add")
                }}</el-button>
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="800px"
        :before-close="closeDia"
        class="carDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <div class="carTitle">
            {{ $t("CompanyManagement.companyInform") }}
          </div>
          <el-form-item
            prop="name"
            :label="$t('CompanyManagement.name') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.name"
              autocomplete="off"
              :disabled="isDisabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="homepageUrlNumber"
            :label="$t('CompanyManagement.homepageUrlNumber') + ':'"
            :label-width="formLabelWidth"
          >
            <el-select
              v-model="form.homepageUrlNumber"
              :placeholder="$t('CompanyManagement.form.homepageUrlNumber')"
              filterable
              :disabled="isDisabled"
            >
              <el-option
                v-for="item in urlList"
                :key="item.id"
                :label="item.dictValue"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="companyNum"
            :label="$t('CompanyManagement.companyNum') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.companyNum"
              autocomplete="off"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="companyAddress"
            :label="$t('CompanyManagement.companyAddress') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.companyAddress"
              autocomplete="off"
              :disabled="isDisabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="responsibleName"
            :label="$t('CompanyManagement.personInCharge') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.responsibleName"
              autocomplete="off"
              :disabled="isDisabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="responsiblePhone"
            :label="$t('CompanyManagement.contactNumberOfThepersonInCharge') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.responsiblePhone"
              autocomplete="off"
              :disabled="isDisabled"
            ></el-input>
          </el-form-item>
          <div style="display: flex">
            <el-form-item
              prop="logoPath"
              :label="$t('CompanyManagement.logoPath') + ':'"
              :label-width="formLabelWidth"
              style="width: 340px; height: 60px"
            >
              <el-upload
                class="avatar-uploader"
                :action="processImg"
                :show-file-list="false"
                :file-list="FileList"
                :on-success="handleAvatarSuccess"
                :on-remove="handleRemove"
                :disabled="isDisabled"
              >
                <img v-if="imageUrl" :src="imageUrl" class="avatars" />
                <i v-else class="el-icon-plus avatars-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item
              v-if="show"
              prop="rolePower"
              :label="$t('CompanyManagement.companyRole') + ':'"
              :label-width="formLabelWidth"
            >
              <el-select
                v-model="form.rolePower"
                :placeholder="$t('common.choseTip')"
                filterable
              >
                <el-option
                  v-for="item in roleList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <!-- <el-button class="btnEdit" @click="changeRole"
                >{{$t('CompanyManagement.btn.changeRole')}}</el-button
              > -->
            </el-form-item>
          </div>
          <div class="carTitle">{{ $t("CompanyManagement.loginInform") }}</div>
          <el-form-item
            prop="loginName"
            :label="$t('CompanyManagement.form.loginName') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.loginName"
              autocomplete="off"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="email"
            :label="$t('CompanyManagement.form.email') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.email"
              autocomplete="off"
              :disabled="isDisabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="userName"
            :label="$t('CompanyManagement.form.userName') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.userName"
              autocomplete="off"
              :disabled="isDisabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="show"
            prop="ResetPass"
            :label="$t('CompanyManagement.form.resetPass') + ':'"
            :label-width="formLabelWidth"
          >
            <el-button class="btnEdit" @click="changePass">{{
              $t("CompanyManagement.form.resetPass")
            }}</el-button>
          </el-form-item>
          <el-form-item
            prop="phone"
            :label="$t('CompanyManagement.adminPhoneNumber') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.phone"
              autocomplete="off"
              :disabled="isDisabled"
            ></el-input>
          </el-form-item>
          <div class="carTitle">{{ $t("CompanyManagement.safeInform") }}</div>
          <el-form-item
            prop="safeLoginName"
            :label="$t('CompanyManagement.safeLoginName') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.safeLoginName"
              autocomplete="off"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="safeEmail"
            :label="$t('CompanyManagement.form.safeEmail') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.safeEmail"
              autocomplete="off"
              :disabled="isDisabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="safeUserName"
            :label="$t('CompanyManagement.safeUserName') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.safeUserName"
              autocomplete="off"
              :disabled="isDisabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="show"
            prop="safeResetPass"
            :label="$t('CompanyManagement.form.resetPass') + ':'"
            :label-width="formLabelWidth"
          >
            <el-button class="btnEdit" @click="changeSafePass">{{
              $t("CompanyManagement.form.resetPass")
            }}</el-button>
          </el-form-item>
          <el-form-item
            prop="safePhone"
            :label="$t('CompanyManagement.securityPhoneNumber') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.safePhone"
              autocomplete="off"
              :disabled="isDisabled"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        width="620px"
        :before-close="closeTransferDia"
        class="transferDialong"
        :title="$t('CompanyManagement.bindOrg')"
        :visible.sync="dialogTransferFormVisible"
        :close-on-click-modal="false"
      >
        <el-form
          :rules="TransferRules"
          ref="TransferForm"
          :model="TransferForm"
        >
          <el-form-item
            prop="name"
            :label="$t('CompanyManagement.name') + ':'"
            :label-width="LabelWidth"
          >
            <el-input
              size="small"
              v-model="TransferForm.name"
              autocomplete="off"
              style="width: 90%"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="roleId"
            :label="$t('CompanyManagement.form.orgTree') + ':'"
            :label-width="LabelWidth"
            v-if="isShow"
          >
            <el-scrollbar>
              <tree :isSearch="isSearch" @nodeClick="changeClick"></tree>
            </el-scrollbar>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancleTransfer('TransferForm')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button
            size="small"
            type="primary"
            @click="submitTransferForm('TransferForm')"
            >{{ typeName }}</el-button
          >
        </div>
      </el-dialog>
      <!-- <el-dialog
        width="820px"
        :before-close="closeRoleDia"
        class="addDialong"
        :title="$t('CompanyManagement.editAdmin')"
        v-if="dialogRoleFormVisible"
        :visible.sync="dialogRoleFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="RoleRules" ref="RoleForm" :model="RoleForm">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                prop="menu"
                :label="$t('CompanyManagement.form.menu')"
                :label-width="formLabelWidth"
              >
                <el-scrollbar>
                  <el-tree
                    :data="data"
                    show-checkbox
                    node-key="id"
                    ref="tree"
                    :expand-on-click-node="false"
                    :default-expanded-keys="checkKeys"
                    :default-checked-keys="checkKeys"
                    :props="defaultProps"
                  >
                  </el-tree>
                </el-scrollbar>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                prop="appMenu"
                :label="$t('CompanyManagement.form.appMenu')"
                :label-width="formLabelWidth"
              >
                <el-scrollbar>
                  <el-tree
                    :data="appData"
                    show-checkbox
                    node-key="id"
                    ref="appTree"
                    :expand-on-click-node="false"
                    :default-expanded-keys="appCheckKeys"
                    :default-checked-keys="appCheckKeys"
                    :props="defaultProps"
                  >
                  </el-tree>
                </el-scrollbar>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancleRoleForm('RoleForm')"
            >{{$t('common.btn.cancel')}}</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="submitRoleForm('RoleForm')"
            >{{$t('common.btn.confirm')}}</el-button
          >
        </div>
      </el-dialog> -->
    </div>
  </div>
</template>

<script>
import CompanyManagement from "./CompanyManagement.js";
export default CompanyManagement;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
